import { gql, useQuery, QueryHookOptions } from '@apollo/client';

export const query = gql`
  query Journeys($hiveId: String!, $gameType: String) {
    journeys(gameType: $gameType, hiveId: $hiveId) {
      _id
      completedAt
      currentStage
      gameType
      userId
      history {
        completedAt
        details
        stageId
        type
      }
    }
  }
`;

export interface StageHistoryType {
  completedAt: string;
  details?: string;
  stageId: string;
  type: string;
}

export interface JourneyType {
  _id: string;
  completedAt?: string;
  currentStage: string;
  gameType: string;
  userId: string;
  history: StageHistoryType[];
}

export interface RequestType {
  gameType?: string;
  hiveId: string;
}

export interface QueryType {
  journeys: JourneyType[];
}

export function useJourneysQuery(
  request: RequestType,
  options?: QueryHookOptions<QueryType, RequestType>,
) {
  return useQuery<QueryType, RequestType>(query, {
    variables: request,
    ...options,
  });
}
